/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isObject } from 'lodash';
import ExpandDetails from 'shared/ui/components/ExpandDetails.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import HtmlEditor from 'shared/ui/components/editors/html/HtmlEditor.vue';

/**
 * @typedef {object} FieldMetadata
 * @prop {string} label
 * @prop {'text'|'html'} kind
 * @prop {string} category
 * @prop {string} [tooltip]
 */

/**
 * @typedef {object} Category
 * @prop {string} category
 * @prop {Array<FieldMetadata & { name: string, value: string }>} fields
 */

const __vue_script__ = {
    name: 'TemplateFieldsMetadata',

    components: { BaseInput, ExpandDetails, HtmlEditor },

    props: {
        fieldsMetadata: {
            type: Object,
            default: () => {},
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            categories: [],
            innerValue: {},
        };
    },

    watch: {
        fieldsMetadata: {
            immediate: true,
            handler() {
                this.onPropChange();
            }
        },
        value: {
            immediate: true,
            handler() {
                this.onPropChange();
            }
        }
    },

    methods: {
        onPropChange() {
            /** @type {Map<string,Array<FieldMetadata & { name: string, value: string }>>} */
            const categoryMap = new Map();
            /** @type {Record<string,FieldMetadata>} */
            const metadata = this.fieldsMetadata;
            /** @type {Record<string,string>} */
            const data = this.value;

            if (!metadata || !data) { return; }

            this.innerValue = {};

            for (const [name, field] of Object.entries(metadata)) {
                // template_name (string) and requirements are handled in parent
                if (!isObject(field) || name === 'requirements') { continue; }

                const categoryName = field.category;
                const fields = categoryMap.get(categoryName) || [];
                fields.push({ ...field, name });
                categoryMap.set(categoryName, fields);

                const value = data[name] || field.default || '';
                this.innerValue[name] = value;
            }

            /** @type {Category[]} */
            const categories = [];
            for (const [category, fields] of categoryMap.entries()) {
                categories.push({ category, fields });
            }
            this.categories = categories;
        },

        onInput(value, key) {
            this.innerValue[key] = value;
            this.$emit('input', this.innerValue);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-fields-metadata" },
    [
      _c(
        "validation-observer",
        { ref: "template-fields-metadata", attrs: { tag: "form" } },
        _vm._l(_vm.categories, function (item) {
          return _c(
            "expand-details",
            { attrs: { label: item.category } },
            [
              _vm._l(item.fields, function (field) {
                return [
                  field.kind === "text"
                    ? _c("validation-provider", {
                        attrs: { slim: true, name: field.name },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("base-input", {
                                    attrs: {
                                      label: field.label,
                                      name: field.name,
                                      errors: errors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput($event, field.name)
                                      },
                                    },
                                    model: {
                                      value: _vm.innerValue[field.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.innerValue,
                                          field.name,
                                          $$v
                                        )
                                      },
                                      expression: "innerValue[field.name]",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  field.kind === "html"
                    ? _c("validation-provider", {
                        attrs: { slim: true, name: field.name },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var errors = ref.errors
                                return [
                                  _c("html-editor", {
                                    attrs: {
                                      label: field.label,
                                      name: field.name,
                                      errors: errors,
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onInput($event, field.name)
                                      },
                                    },
                                    model: {
                                      value: _vm.innerValue[field.name],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.innerValue,
                                          field.name,
                                          $$v
                                        )
                                      },
                                      expression: "innerValue[field.name]",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                ]
              }),
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/organizations/legal-documents/TemplateFieldsMetadata.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__